import URLParser from "@/managers/comunication/URLParser";
import { Signals } from "@/Imports";
import Facade from "@/Facade";
import Utils from "@base/utils/Cheat";

// undefined
export default class GCRequests {
  constructor() {
    this.URLParser = new URLParser();
    this.adress = process.env.NODE_ENV_BACKEND;
    this.init();
  }
  init() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    let value = params.localData; // "some_value"

    if (process.env.NODE_ENV === "development" && value) {
      console.log(
        "%c" + process.env.NODE_ENV + ": USING CHEAT",
        "color:white;background: blue"
      );
      Utils.setCheat(value);
    }
    console.log("API INIT");
    this.gameXHR = new XMLHttpRequest();
    this.gameXHR.addEventListener("error", this.onError.bind(this));
    this.gameXHR.addEventListener("load", this.onGameLoad.bind(this));
  }

  getInit(data) {
    let requestData = {
      //urlData: data,
      ext_params: data.extParams,
      customer: data.customer,
      game_code: data.gameCode, // ? data.gameCode : "undead_vikings",
      platform: data.platform, // ? data.platform : "desktop",
      casino_token: data.casinoToken, // ? data.casinoToken : "calayroche",
      currency: data.currency, // ? data.currency : "EUR",
      language: data.language, // ? data.language : "en",
      play_for_fun: data.playForFun, // ? data.playForFun : false,
      player_uid: data.playerUid, // ? data.playerUid : "92cf4ded-2417-419b-bdac-cb05d26e8ca6" //"bd1783ba-de7e-4870-a6cf-21be7be001f2"
    };

    this.lastAction = "init";
    this.sendMessage(requestData, "authenticate");
  }

  getSpin(data) {
    Facade.status = null;
    let requestData = {
      game_code: this.URLParser.data.gameCode,
      session_token: this.sessionToken,
      amount: data.amount,
      type: "bet",
      cleanup: window.cleanup,
      force_freebet: this.URLParser.forceFreebet || window.force_freebet,
      currency: Facade.model.currentcyCode,
      // lines_played: 0,
      coin_value: data.coinValue,
      force_reality: window.force_reality,
      force_symbol_replace: window.force_symbol_replace,
      force_grids: window.force_grids,

      force_coin_amount: window.force_coin_amount
    };

    this.sendMessage(requestData, "bet");
    Facade.model.lastSpinTime = new Date();

    this.lastAction = "spin";
    window.force_reality = false;
    // window.force_symbol_replace = false
    window.force_freebet = false;
    window.force_grids = null;
    //  window.force_gift = null
    window.cleanup = false;
  }

  getBuyFreespin(data) {
    // Facade.status = null
    let requestData = {
      game_code: this.URLParser.data.gameCode,
      session_token: this.sessionToken,
      amount: data.buyFreebet.price, //Facade.model.fixedCoinsBet,
      type: "buy_freebet",
      currency: Facade.model.currentcyCode,
      coin_value: data.coinValue,
      buy_freebet_id: data.buyFreebet.id,
    };
    this.sendMessage(requestData, "bet");

    this.lastAction = "buy_freebet";
  }

  getTerminate() {
    let requestData = {
      game_code: this.URLParser.data.gameCode,
      session_token: this.sessionToken,
      type: "terminate",
    };
    this.sendMessage(requestData, "terminate");
    console.log(`%c terminate`, "color:white;background: red");
    this.lastAction = "terminate";
  }

  getBalance() {
    let requestData = {
      casino_token: this.URLParser.data.casinoToken,
      session_token: this.sessionToken,
      type: "balance",
    };
    this.sendMessage(requestData, "balance");
    console.log(`%c balance`, "color:white;background: red");
    this.lastAction = "balance";
  }

  sendMessage(data, action) {
    this.gameXHR.open("POST", this.adress + action, true);
    this.gameXHR.setRequestHeader("Content-Type", "application/json");
    this.gameXHR.setRequestHeader("Access-Control-Allow-Origin", "*");
    this.gameXHR.send(JSON.stringify(data));

    console.log("req", JSON.stringify(data));
    // BonusGameContainer.showTime("sendMessage")
  }

  onError(event) {
    Signals.errorConnection.dispatch();
    console.log("ERROR", event);
  }

  onGameLoad(event) {
    //BonusGameContainer.showTime("ON_GET_RESPONCE")
    let data = JSON.parse(event.target.response);
    if (data.hasOwnProperty("error")) {
      Signals.sessionTimeout.dispatch();
      console.log("SERVER ERROR: ", data.message);

      return;
    }
    // if (data.bonus) {
    //   console.log(`%cgift: ${!!data.bonus.game_bonuses}`, "color:white;background: green");
    // }

    if (data.status && data.status == 911) {
      Facade.status = 911;
      /*
          Должно приходить с сервера с правильным текстом

          if (data.message === "Not enough balance"){   //todo change it
            Signals.notEnoughMoney.dispatch(data)
            return
          }
          if (data.title === 'Casino error') {
            Signals.casinoError.dispatch(data)
          }
       */
      Signals.realityCheck.dispatch(data);
      return;
    }
    switch (this.lastAction) {
      case "init":
        this.onInitLoad(data);
        break;
      case "spin":
        this.onSpinLoad(data);
        break;
      case "buy_freebet":
        this.onBuyFreespin(data);
        break;
      case "balance":
        this.onBalance(data);
        break;
    }
  }

  onBalance(data) {
    this.sessionToken = data.session_token;
    Signals.backendMessage.dispatch({ action: "balance", data: data });
  }

  onInitLoad(data) {
    this.sessionToken = data.session_token;
    Signals.backendMessage.dispatch({ action: "init", data: data });
  }

  onSpinLoad(data) {
    Signals.backendMessage.dispatch({ action: "spin", data: data });
  }

  onBuyFreespin(data) {
    Signals.backendMessage.dispatch({ action: "buy_freebet", data: data });
  }

  /*onBackendError(data) {
    ErrorManager.backendError(data);
  }*/
}
